import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { CustomFieldLevelLoader } from "../utils/CommonLibrary";
import { Link } from "react-router-dom";
import {
  decryptCipherJson,
  decryptCipherString,
} from "../cn/components/common/Utils";
// import './MemberServices.css';

const HomeService = ({
  modalHeader,
  showServiceModal,
  hideServiceModal,
  serviceIdModal,
  serviceTypeModal,
  fetchHomeServiceDetails,
  refreshPreauth,
  showRescheduleModal,
  rerender,
}) => {
  const [serviceDetails, setServiceDetails] = useState([]);
  const [serviceLogs, setServiceLogs] = useState([]);
  const [medicationsData, setMedicationsData] = useState([]);
  const [suppliesData, setSuppliesData] = useState([]);
  const [showRefreshButton, setShowRefreshButton] = useState("true");
  const [showPreauth, setShowPreauth] = useState("true");
  const [errorNew, setErrorNew] = useState("");
  const [messageNew, setMessageNew] = useState("");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServiceDetails();
  }, [rerender]);

  console.log(serviceIdModal, "service details");

  const fetchServiceDetails = () => {
    fetchHomeServiceDetails(serviceIdModal, serviceTypeModal).then(
      (response) => {
        setServiceDetails(response.data.data?.serviceData);
        setServiceLogs(response.data.data?.serviceLog);
        setMedicationsData(response.data.data?.medications);
        setSuppliesData(response.data.data?.supplies);
        setShowPreauth(response.data.data?.showPreauthStatus);
        setLoading(false);
      },
    );
  };

  const refreshPreauthEdge = async () => {
    setMessageNew("");
    setErrorNew("");
    setShowRefreshButton("false");

    refreshPreauth(serviceIdModal, serviceTypeModal).then((response) => {
      if (response.data.code === 200) {
        fetchServiceDetails();
        setMessageNew(response.data.data.message);
      } else {
        setErrorNew(response.data.data.message);
      }
      setTimeout(() => {
        setMessageNew("");
        setErrorNew("");
      }, 2000);
      setShowRefreshButton("true");
    });
  };

  return (
    <>
      <Modal
        id="hbsh"
        show={showServiceModal}
        centered
        onHide={hideServiceModal}
        size="xl"
        backdrop="static"
        keyboard={false}
        fullscreen={false}
      >
        <Modal.Header closeButton>
          <h1 className="modal-title" style={{ width: "100%" }}>
            {modalHeader}
          </h1>
        </Modal.Header>
        <Modal.Body>
          <>
            {loading ? (
              <div className="text-center">
                <CustomFieldLevelLoader />
              </div>
            ) : (
              <div className="container">
                <div className="row">
                  {serviceDetails?.map((item, index) => {
                    return (
                      <>
                        <div className="col-md-4 mb-3" key={index}>
                          <label>{item.title}</label>
                          {item.title == "Approval Number" &&
                            showPreauth == "true" &&
                            (showRefreshButton == "true" ? (
                              <span
                                className="tw-cursor-pointer tw-mb-2.5 tw-ml-2"
                                onClick={refreshPreauthEdge}
                              >
                                <i
                                  className="bi bi-arrow-clockwise"
                                  style={{ fontSize: "0.9rem" }}
                                ></i>
                              </span>
                            ) : (
                              <span className="tw-mb-2.5 tw-ml-2">
                                <img
                                  src="https://storage.googleapis.com/ksabupatest/2024/09/24/3lsab/y968s2s843.gif"
                                  style={{ height: "20px" }}
                                  alt=""
                                />
                              </span>
                            ))}
                          <br />
                          {(() => {
                            if (item.title == "Reschedule") {
                              return (
                                <>
                                  <button
                                    className="btn btn-light action-dropdown-btn"
                                    onClick={() =>
                                      showRescheduleModal(serviceIdModal, "hbl")
                                    }
                                  >
                                    <i className="bi bi-calendar4-week"></i>
                                  </button>
                                </>
                              );
                            } else if (item.title === "Action") {
                              return (
                                <>
                                  <div className="DropDownAction">
                                    <div className="btn-group dropend mt-1">
                                      <button
                                        type="button"
                                        className="btn btn-light dropdown-toggle action-dropdown-btn"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="bi bi-eye"></i>
                                      </button>
                                      <ul className="dropdown-menu">
                                        {item?.value?.map((child, indexCh) => (
                                          <li
                                            className="list-class"
                                            key={indexCh}
                                          >
                                            <Link
                                              className="dropdown-item"
                                              target="_blank"
                                              to={child.link}
                                            >
                                              {child.name}
                                            </Link>
                                          </li>
                                        ))}
                                      </ul>
                                    </div>
                                  </div>
                                </>
                              );
                            } else {
                              return (
                                <>
                                  <span>{item.value}</span>
                                </>
                              );
                            }
                          })()}
                        </div>
                      </>
                    );
                  })}
                  <div
                    className={`${errorNew != "" ? "errorDiv" : "hide"}`}
                    style={{ fontWeight: "400 !important" }}
                  >
                    {errorNew}
                  </div>
                  <div
                    className={`${messageNew != "" ? "messageDivNew" : "hide"}`}
                    style={{
                      fontWeight: "400 !important",
                      color: "black !important",
                    }}
                  >
                    {messageNew}
                  </div>
                </div>

                {medicationsData?.length > 0 && (
                  <div
                    className="table-responsive mt-2"
                    style={{ maxHeight: "380px", overflowX: "hidden" }}
                  >
                    <label>Medications</label>
                    <br />
                    <table className="table table-striped table-bordered mb-0">
                      <thead style={{ position: "sticky", top: "0" }}>
                        <tr>
                          <th scope="col">SFDA</th>
                          <th scope="col">Product</th>
                          <th scope="col">Frequency</th>
                          <th scope="col">Duration</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Supply From</th>
                          <th scope="col">Supply To</th>
                          <th scope="col">Comments</th>
                          <th scope="col">Provider</th>
                          <th scope="col">Source</th>
                        </tr>
                      </thead>
                      <tbody>
                        {medicationsData?.map((item, index) => {
                          return (
                            <>
                              <tr
                                style={{ verticalAlign: "middle" }}
                                key={index}
                              >
                                <td className="bg-td-green">{item.sfdaCode}</td>
                                <td className="bg-td-green">
                                  {item.productName}
                                </td>
                                <td className="bg-td-green">
                                  {item.frequencyName}
                                </td>
                                <td className="bg-td-green">{item.duration}</td>
                                <td className="bg-td-green">{item.quantity}</td>
                                <td className="bg-td-green">
                                  {item.supplyFrom}
                                </td>
                                <td className="bg-td-green">{item.supplyTo}</td>
                                <td className="bg-td-green">{item.comments}</td>
                                <td className="bg-td-green">
                                  {item.providerName}
                                </td>
                                <td className="bg-td-green">{item.source}</td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                {suppliesData?.length > 0 && (
                  <div
                    className="table-responsive mt-2"
                    style={{ maxHeight: "380px", overflowX: "hidden" }}
                  >
                    <label>Supplies</label>
                    <br />
                    <table className="table table-striped table-bordered mb-0">
                      <thead style={{ position: "sticky", top: "0" }}>
                        <tr>
                          <th scope="col">SFDA</th>
                          <th scope="col">Product</th>
                          <th scope="col">Quantity</th>
                          <th scope="col">Comments</th>
                          <th scope="col">Provider</th>
                          <th scope="col">Source</th>
                        </tr>
                      </thead>
                      <tbody>
                        {suppliesData?.map((item, index) => {
                          return (
                            <>
                              <tr
                                style={{ verticalAlign: "middle" }}
                                key={index}
                              >
                                <td className="bg-td-green">{item.sfdaCode}</td>
                                <td className="bg-td-green">
                                  {item.productName}
                                </td>
                                <td className="bg-td-green">{item.quantity}</td>
                                <td className="bg-td-green">{item.comments}</td>
                                <td className="bg-td-green">
                                  {item.providerName}
                                </td>
                                <td className="bg-td-green">{item.source}</td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}

                {serviceLogs && (
                  <div
                    className="table-responsive mt-2"
                    style={{ maxHeight: "380px", overflowX: "hidden" }}
                  >
                    <table className="table table-striped table-bordered mb-0">
                      <thead style={{ position: "sticky", top: "0" }}>
                        <tr>
                          <th scope="col">Date</th>
                          <th scope="col">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceLogs?.map((item, index) => {
                          return (
                            <>
                              <tr style={{ verticalAlign: "middle" }}>
                                <td className="bg-td-green" key={index}>
                                  {item.createdTime}
                                </td>
                                <td className="bg-td-green">{item.action}</td>
                              </tr>
                            </>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HomeService;
